import React from 'react';
import { Link } from 'react-router-dom';

import {
  APP_CONFIG_AGILE_SUITE,
  VIEW_PATHS_ORDER_MANAGER,
} from '@hcs/app-configs';

import { DATA_HC_NAME_REPORT_SUMMARY_TABLE_CELL } from '../../../constants/ReportSummary.constants';
import { ReportSummaryCellContentProps } from '../../../types';

import { createReportSummaryTableCellConfig } from './ReportSummaryTableCell';

import styles from './Order.module.css';

const dataHcName = `${DATA_HC_NAME_REPORT_SUMMARY_TABLE_CELL}-order`;
// eslint-disable-next-line react-refresh/only-export-components
const CellContentComponent = ({ order }: ReportSummaryCellContentProps) => (
  <div data-hc-name={`${dataHcName}`}>
    <Link
      data-hc-name={`${dataHcName}-link`}
      to={`${APP_CONFIG_AGILE_SUITE.rootPath}${VIEW_PATHS_ORDER_MANAGER.ORDER}/${order.id}`}
      className={styles.Link}
    >
      {order.name}
    </Link>
  </div>
);

export const REPORT_SUMMARY_ORDER_CONFIG = createReportSummaryTableCellConfig({
  CellContentComponent,
  tableHeaderName: 'Order',
});
